import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'types';
import { initialState } from './Confetti.redux';

const selectDomain = (state: RootState) => state?.confettiDetails || initialState;

export const selectConfettiDetails = createSelector([selectDomain], confettiDetails => confettiDetails);
